var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 3C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H9",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V3.5L16 3",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12C12.3284 12 13 11.3284 13 10.5C13 9.67157 12.3284 9 11.5 9C10.6716 9 10 9.67157 10 10.5C10 11.3284 10.6716 12 11.5 12Z",
    stroke: "#067BF9",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#067BF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.668 22L5.892 15.52H7.524L8.732 22H7.412L7.196 20.632H6.244L6.02 22H4.668ZM6.372 19.776H7.06L6.716 17.248L6.372 19.776ZM9.55425 22L10.7783 15.52H12.4103L13.6183 22H12.2983L12.0823 20.632H11.1303L10.9063 22H9.55425ZM11.2583 19.776H11.9463L11.6023 17.248L11.2583 19.776ZM16.5069 22.096C16.0163 22.096 15.6269 22.008 15.3389 21.832C15.0563 21.6507 14.8563 21.4 14.7389 21.08C14.6216 20.7547 14.5629 20.3733 14.5629 19.936V17.6C14.5629 17.152 14.6216 16.768 14.7389 16.448C14.8563 16.1227 15.0563 15.872 15.3389 15.696C15.6269 15.52 16.0163 15.432 16.5069 15.432C16.9869 15.432 17.3603 15.512 17.6269 15.672C17.8989 15.8267 18.0909 16.0453 18.2029 16.328C18.3149 16.6107 18.3709 16.936 18.3709 17.304V17.864H16.9709V17.216C16.9709 17.088 16.9629 16.9653 16.9469 16.848C16.9363 16.7307 16.8989 16.6347 16.8349 16.56C16.7709 16.48 16.6616 16.44 16.5069 16.44C16.3576 16.44 16.2456 16.48 16.1709 16.56C16.1016 16.64 16.0563 16.7413 16.0349 16.864C16.0189 16.9813 16.0109 17.1067 16.0109 17.24V20.288C16.0109 20.432 16.0216 20.5653 16.0429 20.688C16.0696 20.8053 16.1176 20.9013 16.1869 20.976C16.2616 21.0453 16.3683 21.08 16.5069 21.08C16.6563 21.08 16.7629 21.0427 16.8269 20.968C16.8909 20.888 16.9309 20.7867 16.9469 20.664C16.9629 20.5413 16.9709 20.416 16.9709 20.288V19.608H18.3709V20.168C18.3709 20.536 18.3149 20.8667 18.2029 21.16C18.0963 21.448 17.9069 21.6773 17.6349 21.848C17.3683 22.0133 16.9923 22.096 16.5069 22.096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAac);
export default __webpack_public_path__ + "static/media/aac.6cadc786b45fcf85a706a4ab8fc58d14.svg";
export { ForwardRef as ReactComponent };